import styled from 'styled-components';

export const StyledList = styled.ul`
  padding-left: 35px;
  list-style: initial;

  li {
    padding-top: 10px;
  }
`;
